const API_URL = 'https://pinata-rotator-worker.torweb321.workers.dev/';

// 上传博客内容到 IPFS（POST /，file 字段）
export async function uploadPost({ title, content }) {
  const blogJson = JSON.stringify({ title, content, timestamp: Date.now() });
  const blob = new Blob([blogJson], { type: 'application/json' });
  const formData = new FormData();
  formData.append('file', blob, 'blog.json');
  const res = await fetch(API_URL, { method: 'POST', body: formData });
  if (!res.ok) throw new Error('上传失败');
  return res.json(); // 返回 Pinata 的响应
}

// 获取所有博客 CID 列表
export async function fetchPostCids() {
  const res = await fetch(API_URL + 'list');
  if (!res.ok) throw new Error('获取博客列表失败');
  return res.json(); // 返回 CID 数组
}

// 通过 CID 获取单篇博客内容
export async function fetchPostByCid(cid) {
  const res = await fetch(API_URL + `post?cid=${cid}`);
  if (!res.ok) throw new Error('获取博客内容失败');
  return res.json(); // 返回博客 JSON
}
